import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem } from '@mui/material';
import Icon from '@mdi/react';
import { mdiDotsHorizontal } from '@mdi/js';
import DeleteCardConfirmPopover from '../common/delete_card_confirm_popover';
import PopupTitle from '../common/popup_title';

const ShoppingListGroupActionsPopupMenu = ({ onDeleteShoppingListGroup }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;
  const [deletePopupAnchorEl, setDeletePopupAnchorEl] = useState(null);

  const handleClick = (event) => {
    setDeletePopupAnchorEl(null);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setDeletePopupAnchorEl(null);
    setAnchorEl(null);
  };
  const handleDelete = () => {
    setDeletePopupAnchorEl(null);
    handleClose();
    onDeleteShoppingListGroup();
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open && 'true'}
        aria-haspopup="true"
        size="small"
        onClick={handleClick}>
        <Icon
          path={mdiDotsHorizontal}
          style={{ width: '24px', height: '24px' }}
        />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        PaperProps={{
          style: { width: '200px' },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <PopupTitle
          titleText="Group actions"
          closeButtonEnabled
          onClickClose={handleClose}
        />
        <MenuItem onClick={(ev) => setDeletePopupAnchorEl(ev.target)}>
          Delete group
        </MenuItem>
      </Menu>
      <DeleteCardConfirmPopover
        anchorEl={deletePopupAnchorEl}
        visible={!!deletePopupAnchorEl}
        onDismiss={() => setDeletePopupAnchorEl(null)}
        message="All the lists in this group will be deleted permanently. Are you sure?"
        onConfirmDelete={handleDelete}
        height={160}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        title="Delete shopping lists"
      />
    </>
  );
};

ShoppingListGroupActionsPopupMenu.propTypes = {
  onDeleteShoppingListGroup: PropTypes.func.isRequired,
};

export default ShoppingListGroupActionsPopupMenu;
